/**
 * O plugin declara se o SDK de Logs foi inicializado. Ler a env aqui duplicaria
 * a fonte de verdade, e este módulo é folha do grafo — não importa `plugins`.
 */
let logsEnabled = false;

export function setObservabilityLogsEnabled(enabled: boolean): void {
  logsEnabled = enabled;
}

export function isObservabilityLogsEnabled(): boolean {
  return logsEnabled;
}
